import { render, staticRenderFns } from "./AllocationClients.vue?vue&type=template&id=119949af"
import script from "./AllocationClients.vue?vue&type=script&lang=js"
export * from "./AllocationClients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports